import { request } from "common/components/request";
import ReactJson from "react-json-view";
import { useQuery } from "react-query";

export function AppsList(props) {
    const getData = () => request("/admin/app_registry/applications");

    const {
        isLoading, isError, data
    } = useQuery(["AppRegistry_apps"], () => getData());

    if (isError) {
        return (<div>Error....</div>);
    }
    if (isLoading) {
        return (<div>.....</div>);
    }

    return (<ReactJson name={false} src={data} theme="apathy:inverted" displayObjectSize={false} iconStyle="triangle" collapsed={1} collapseStringsAfterLength="30" displayDataTypes={false} sortKeys displayArrayKey={false} quotesOnKeys={false}/>);
}
